module.exports = __webpack_public_path__ + "static/media/icon_alert_fail.ea20c2bf.svg";